import { useTheme } from "@mui/material/styles";
import { Box as BoxIcon, DollarCircle, Wallet2 } from "iconsax-react";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { CompactStatsRow } from "@/components/Organisms";
import { formatPersianNumber } from "@/lib/format/persian";
import type { DashboardStatsRowProps } from "../DashboardStatsRow/DashboardStatsRow.types";

export type { DashboardStatsRowProps };

export const DashboardStatsRow = memo(function DashboardStatsRow({
  todaySales,
  awaitingPayment,
  preparing,
  isLoading = false,
}: DashboardStatsRowProps) {
  const { t } = useTranslation("home");
  const theme = useTheme();
  const isEmpty = todaySales === 0 && awaitingPayment === 0 && preparing === 0;

  return (
    <CompactStatsRow
      isLoading={isLoading}
      items={[
        {
          value: isEmpty ? "۰" : formatPersianNumber(todaySales),
          label: t("dashboard.stats.todaySalesCompact"),
          accentColor: theme.palette.primary.main,
          softBg: `${theme.palette.primary.main}1A`,
          icon: <Wallet2 size={19} variant="Bold" color={theme.palette.primary.main} />,
        },
        {
          value: isEmpty ? "۰" : formatPersianNumber(awaitingPayment),
          label: t("dashboard.stats.awaitingPaymentCompact"),
          accentColor: theme.palette.warning.main,
          softBg: `${theme.palette.warning.main}1F`,
          icon: <DollarCircle size={19} variant="Bold" color={theme.palette.warning.main} />,
        },
        {
          value: isEmpty ? "۰" : formatPersianNumber(preparing),
          label: t("dashboard.stats.preparingCompact"),
          accentColor: theme.palette.secondary.main,
          softBg: `${theme.palette.secondary.main}1A`,
          icon: <BoxIcon size={19} variant="Bold" color={theme.palette.secondary.main} />,
        },
      ]}
    />
  );
});
